export var TEXT_TOOLS_TYPE = 'TEXT_TOOLS';
//# sourceMappingURL=types.js.map